import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { Datafeed } from '../../../interfaces/datafeed';
import { DialogDefinition } from '../../../services/overlay.service';
import { Observable, Subject } from 'rxjs';

@Component({
	selector: 'datafeed-details',
	templateUrl: './datafeed-details.component.html',
	styleUrls: ['./datafeed-details.component.scss']
})


export class DatafeedDetailsComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;

	constructor(
		protected route: ActivatedRoute,
		protected location: Location) {

		super(route, location);
		this.entityConfiguration = {
			name: 'datafeed',
			entityType: 'datafeed',
			parentPath: '/library/datafeeds',
			basePath: '/library/datafeed/',
			versioned: true,
			showVersionMetadata: true,
			versionMetadataToSave: {
				bbcomment: ''
			},
			defaults: {
				rows: [{}],
				columns: [],
				feedType: 'default',
				subtype: 'versioned',
				status: 'active'
			}
		};
	}

	get datafeed(): Datafeed {
		return this.entity as Datafeed;
	}

	save(force: boolean, extraHeaders?: any, saveDirectly: boolean = false, publish?: boolean): Observable<any> {
		const datafeed = this.entity as Datafeed;

		if ((datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport') &&
			(!Array.isArray(datafeed.fieldMapping) || !datafeed.fieldMapping.find(mapping => mapping.key === 'sourceid'))) {
			const saveFinished = new Subject<any>();

			const dialog: DialogDefinition = {
				icon: 'warning',
				title: this.translate.instant('IMPORT_FEED_SOURCEID_NOT_MAPPED'),
				contents: this.translate.instant('IMPORT_FEED_SOURCEID_NOT_MAPPED_WARNING'),
				onConfirm: () => {
					const saveObservable = super.save(force, extraHeaders, saveDirectly, publish);
					saveObservable.subscribe(() => {
						saveFinished.next(this.entity);
					});
				}
			};

			this.overlayService.createDialog(dialog);
			return saveFinished;
		} else {
			const saveObservable = super.save(force, extraHeaders, saveDirectly, publish);
			saveObservable.subscribe();
			return saveObservable;
		}
	}

	ngOnInit() {
		super.ngOnInit();
	}
}
